import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  RouterProvider as TanStackRouterProvider,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { FC } from "react";
import { App } from "../App";

type SearchParams = {
  orderbookGridId?: string;
  algosArea?: string;
  bottomView?: string;
  ghostbooks?: string;
};

export const rootRoute = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
});

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    return {
      orderbookGridId: (search.orderbookGridId as string) ?? undefined,
      algosArea: (search.algosArea as string) ?? undefined,
      bottomView: (search.bottomView as string) ?? undefined,
      ghostbooks: (search.ghostbooks as string) ?? undefined,
    };
  },
  component: App,
});

const routeTree = rootRoute.addChildren([indexRoute]);

const router = createRouter({
  routeTree,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export const RouterProvider: FC = () => {
  return <TanStackRouterProvider router={router} />;
};
